import { throttleToAnimationFrame } from './utils/utils';
import wixBgImageWrapper from './elements/wixBgImage/wixBgImage';
import wixBgMediaWrapper from './elements/wixBgMedia/wixBgMedia';
import wixDropdownMenuWrapper from './elements/wixDropdownMenu/wixDropdownMenu';
import wixElementWrapper from './elements/wixElement';
import wixIframeWrapper from './elements/wixIframe/wixIframe';
import wixImageWrapper from './elements/wixImage/wixImage';
import wixVideoWrapper from './elements/wixVideo/wixVideo';

function init(services) {
  require('./shims/native-shim');

  var resizeObserver = services.resizeService.init(function (entries) {
    return entries.forEach(function (entry) {
      return entry.target.reLayout();
    });
  });
  var windowResizeService = {
    registry: new Set(),
    observe: function observe(element) {
      windowResizeService.registry.add(element);
    },
    unobserve: function unobserve(element) {
      windowResizeService.registry["delete"](element);
    }
  };
  services.windowResizeService.init(throttleToAnimationFrame(function () {
    return windowResizeService.registry.forEach(function (element) {
      return element.reLayout();
    });
  }));
  var resizeService = {
    observe: function observe(element) {
      resizeObserver.observe(element);
    },
    unobserve: function unobserve(element) {
      resizeObserver.unobserve(element);
    }
  };
  var WixElement = wixElementWrapper({
    resizeService: resizeService
  });
  defineCustomElement('wix-element', WixElement);
  return {
    defineWixImage: defineWixImage.bind(null, WixElement),
    defineWixBgImage: defineWixBgImage.bind(null, WixElement),
    defineWixBgMedia: defineWixBgMedia.bind(null, WixElement, windowResizeService),
    defineWixDropdownMenu: defineWixDropdownMenu.bind(null, WixElement),
    defineWixVideo: defineWixVideo.bind(null, WixElement),
    defineWixIframe: defineWixIframe.bind(null, WixElement)
  };
}

function defineCustomElement(elementName, elementClass) {
  if (customElements.get(elementName) === undefined) {
    customElements.define(elementName, elementClass);
  }
}

function defineWixImage(WixElement, externalServices, environmentConsts) {
  var WixImage = wixImageWrapper(WixElement, externalServices, environmentConsts);
  defineCustomElement('wix-image', WixImage);
}

function defineWixBgImage(WixElement, externalServices, environmentConsts) {
  var WixBgImage = wixBgImageWrapper(WixElement, externalServices, environmentConsts);
  defineCustomElement('wix-bg-image', WixBgImage);
}

function defineWixBgMedia(WixElement, windowResizeService, externalServices) {
  var WixBgMedia = wixBgMediaWrapper(WixElement, windowResizeService, externalServices);
  defineCustomElement('wix-bg-media', WixBgMedia);
}

function defineWixDropdownMenu(WixElement, externalServices) {
  var WixDropdownMenu = wixDropdownMenuWrapper(WixElement, externalServices);
  defineCustomElement('wix-dropdown-menu', WixDropdownMenu);
}

function defineWixVideo(WixElement, externalServices, environmentConsts) {
  var WixVideo = wixVideoWrapper(WixElement, externalServices, environmentConsts);
  defineCustomElement('wix-video', WixVideo);
}

function defineWixIframe(WixElement, externalServices) {
  var WixIframe = wixIframeWrapper(WixElement, externalServices);
  defineCustomElement('wix-iframe', WixIframe);
}

export default {
  init: init
};
//# sourceMappingURL=wixCustomElementsRegistry.js.map